import { HeadCell } from '@dfl/mui-admin-layout';
import { GroupNameCell } from 'modules/analytics/common/components/Cells';
import { GroupedListData } from 'modules/analytics/common/types';

export const groupNameColumn: HeadCell<GroupedListData> = {
  field: 'name',
  headerName: 'groupNameColumn',
  disablePadding: false,
  renderCell: (value, data) => <GroupNameCell name={value} isGroup={data.isGroup} />,
};
